;(() => {
  // Wrapper around crypto.randomUUID() with a small fallback for non-secure contexts
  // (older Safari/iOS, http on staging) where it is undefined. Generated session ids
  // only need uniqueness within a single browser tab, so this is sufficient.
  function uuidv4() {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID()
    }
    // RFC 4122 v4-shaped fallback
    const bytes = new Uint8Array(16)
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.getRandomValues === "function"
    ) {
      crypto.getRandomValues(bytes)
    } else {
      for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256)
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"))
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`
  }

  window.HB = window.HB || {}
  window.HB.uuidv4 = uuidv4
})()
